import { render, staticRenderFns } from "./WarehouseList.vue?vue&type=template&id=740a3fe0&scoped=true"
import script from "./WarehouseList.vue?vue&type=script&lang=js"
export * from "./WarehouseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740a3fe0",
  null
  
)

export default component.exports